import React from 'react';
import "./components.css";
import logo from "./../images/sigma-612x612.jpg";
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router-dom';

const TopBar = () => {

  return (
    <div>
        <nav class="navbar navbar-expand-md navbar-dark bg-primary fixed-top">
        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <Link to="/" class="navbar-brand" href="#">
            <img src={logo} width="30" height="30" class="d-inline-block align-top" alt="" />
            <span class="menu-collapsed">PROJECT SIGMA</span>
        </Link>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav">
                <li class="nav-item active">
                <Link to="/" class="nav-link" href="#">Home <span class="sr-only">(current)</span></Link>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Components</a>
                </li>        

                {/* This menu is hidden in bigger devices with d-sm-none. 
              The sidebar isn't proper for smaller screens imo, so this dropdown menu can keep all the useful sidebar itens exclusively for smaller screens  */}
                <li class="nav-item dropdown d-sm-block d-md-none">
                    <a class="nav-link dropdown-toggle" href="#" id="smallerscreenmenu" type="button" data-toggle="dropdown">
                      Solutions
                    </a>
                    <div class="dropdown-menu" aria-labelledby="smallerscreenmenu">
                        <Link to='/solutions/1-10' class="dropdown-item" href="#">Solution 1 - 10</Link>
                        <Link to='/solutions/1-10' class="dropdown-item" href="#">Solution 11 - 20</Link>
                    </div>
                </li>
                {/* Smaller devices menu END */}

            </ul>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <form class="form-inline">
                        <input class="form-control mr-sm-2" type="search" placeholder="Search Project Sigma" />
                        <button class="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>
                    </form>
                </li>
            </ul>
        </div>
    </nav>  
  </div>
  )
}

export default TopBar
